import React from "react";
import Dropzone from "react-dropzone";
import styles from "./ThemeSettings.module.scss";
import { Icon } from "../../../atoms/Icon";

export default function ImageUploadPanel({
  onImageChange,
  image,
  disabled = false
}) {
  return (
    <Dropzone onDrop={onImageChange} accept="image/*" disabled={disabled}>
      {({ getRootProps, getInputProps }) => (
        <div {...getRootProps()} className={styles.dropzone}>
          <input {...getInputProps()} />
          {image ? (
            <img src={image} />
          ) : (
            <p>PNG or JPEG format, 1920 x 1080 px, 3 MB (or less).</p>
          )}
          <div className={styles.uploadIcon}>
            <Icon name="export" size={9} color="#2c2f34" />
          </div>
        </div>
      )}
    </Dropzone>
  );
}
